<script setup lang="ts">
  import { Routes } from '@/const/Routes'
  import type { Subject } from '@/types/Subject'
  import { useAppRouting } from '@/composables/useAppRouting'

  import BorderList from '@/components/common/BorderList.vue'
  import CircleArrow from '@/components/icons/CircleArrow.vue'
  import Typography from '@/components/common/Typography.vue'
  import { computed } from 'vue'
  import { useUser } from '@/composables/useUser'

  const props = defineProps<{
    subjects: Subject[]
  }>()

  const { getRouteWithParams } = useAppRouting()

  const { isInAschehougOrganization } = useUser()

  const filteredSubjects = computed(() => (
    props.subjects.filter(subject => (
      !subject.title.toLowerCase().includes('innhold under utvikling') || isInAschehougOrganization.value
    ))
  ))

</script>

<template>
  <nav>
    <BorderList>
      <li
        v-for="subject in filteredSubjects"
        :key="subject.title"
      >
        <router-link
          :to="getRouteWithParams(Routes.Subject, subject)"
          class="content"
        >
          <div>
            <Typography
              variant="label"
              class="subject-label"
            >
              {{ subject.label }}
            </Typography>
            <Typography
              component="h3"
              variant="h2"
              class="subject-title"
            >
              {{ subject.title }}
            </Typography>
          </div>
          <CircleArrow />
        </router-link>
      </li>
    </BorderList>
  </nav>
</template>

<style lang="scss" scoped>
  .subject-title {
    margin: 0;
  }

  .content {
    display: flex;
    flex: 1;
    padding: 24px 32px;
    color: var(--color-blue-50);
    line-height: 150%; /* 42px */
    text-decoration: none;
    transition: all .15s;
    justify-content: space-between;
    align-items: center;

    @include visible-focus-ring;

    &:focus-visible,
    &:hover {
      background-color: var(--color-yellow-20);
    }

    @include vgs-media-mobile {
      padding: 14px 10px 14px 17px;
    }

    svg {
      fill: transparent;
      flex-shrink: 0;
    }

    .subject-content-title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
